var gallery = {
	selectors: { },

	init: function () {
		var self = this;

		jQuery( document ).on('click', '.js-filter-gallery-nav a', function (e) {
			e.preventDefault();

			var group_selector = jQuery(this).attr( 'href');
			group_selector = group_selector.substr( 1, group_selector.length);

			jQuery( this ).closest('ul').find('.active').removeClass('active');
			jQuery( this ).parent().addClass('active');

			if( group_selector == 'gallery-all') {
				jQuery( this ).parents('.filter-gallery').find('.js-filter-gallery-item').show();
			}
			else {
				jQuery( this ).parents('.filter-gallery').find('.js-filter-gallery-item').hide();
				jQuery( this ).closest('.filter-gallery').find('.' + group_selector).show();
			}

		});
	},
};

export { gallery };
